export const showRoles = (roles) => {
  if ("Admin" in roles) {
    return "Admin";
  }
  if ("Editor" in roles) {
    return "Editor";
  }
  return "User";
};
